import React, { Component } from "react";

//router
import { NavLink } from "react-router-dom";

//redux
import { connect } from "react-redux";

//components
import CustomButton from "../../../../../generic_components/components/buttons/CustomButton";

//generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions"

//import static routes
import {
    cari_home_pg_url,
} from "../../../../../router/static_routes";

import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";

//redux mapper
const mapStateToProps = state => {
    return {
        activePositionData: state.cariReducer.activePositionData
    };
};

class CariAppFormPgSubmitted extends Component {

    constructor(props) {
        super(props);

        //get redux store data
        this.get_active_position_data_from_store = this.get_active_position_data_from_store.bind(this);
    }

    //get active position from redux store
    get_active_position_data_from_store() {
        var copyPositionData = this.props.activePositionData;

        if (!isEmpty(copyPositionData)) {
            return copyPositionData;
        }
        else {
            return { "position_id": null, "position_title": "Position Title" }
        }
    }

    render() {
        return (
            <div className="scene_element scene_element--fadeinright">
                <br/><br/>
                <div className="">
                    <div className="p-grid">   
                        <div className="p-col-12 continuing_home_height">      

                            <CustomButton
                                icon={"check"}
                                label={"Submitted"}
                                iconLocation={"left"}
                                iconSize={"lg"}
                                className={"p-button-success"}
                                btnRaised={true}
                                staticBtn={true}
                            />

                            <br/>
                            <br/>

                            <p className="cari_small_text">
                                Thank you for applying to the Beedie School of Business for the position of: 
                                <br/>
                                <strong>{this.get_active_position_data_from_store().position_title}</strong>
                                <br/>
                                <br/>
                                Your application has been received. Only short-listed candidates will be contacted. 
                            </p>
                            <strong className="cari_small_text"> 
                                To apply for other positions, please click "Home" on the side menu or&nbsp;
                                <NavLink 
                                    to={cari_home_pg_url}
                                >
                                    <u>click here</u>.
                                </NavLink>
                            </strong>
                            
                        </div>    
                    </div>   
                </div>

                <CariMainPgFooterView />  
            </div>
        );
    }
}
export default connect(mapStateToProps)(CariAppFormPgSubmitted);